import { gql } from "@apollo/client";

// ─── Template Queries ────────────────────────────────────────────────────────

export const GET_NOTIFICATION_TEMPLATES = gql`
  query NotificationTemplates($category: String, $isActive: Boolean) {
    notificationTemplates(category: $category, isActive: $isActive) {
      _id
      name
      version
      locale
      title
      body
      channelId
      sound
      priority
      category
      isActive
      createdBy
      variables {
        name
        type
        required
        defaultValue
        description
        example
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_TRIGGER_CONTRACTS = gql`
  query NotificationTriggerContracts {
    notificationTriggerContracts {
      templateName
      description
      notificationType
      providedVariables {
        name
        type
        description
        example
      }
    }
  }
`;

export const PREVIEW_NOTIFICATION_TEMPLATE = gql`
  query PreviewNotificationTemplate($input: PreviewNotificationTemplateInput!) {
    previewNotificationTemplate(input: $input) {
      title
      body
      validation {
        valid
        errors
        warnings
      }
    }
  }
`;

// ─── Template Mutations ──────────────────────────────────────────────────────

export const SAVE_NOTIFICATION_TEMPLATE = gql`
  mutation SaveNotificationTemplate($input: SaveNotificationTemplateInput!) {
    saveNotificationTemplate(input: $input) {
      _id
      name
      version
      locale
      title
      body
      channelId
      priority
      category
      isActive
      updatedAt
    }
  }
`;

export const DEACTIVATE_NOTIFICATION_TEMPLATE = gql`
  mutation DeactivateNotificationTemplate($name: String!, $locale: String!) {
    deactivateNotificationTemplate(name: $name, locale: $locale)
  }
`;

// ─── Admin Send ──────────────────────────────────────────────────────────────

export const SEND_ADMIN_NOTIFICATION = gql`
  mutation SendAdminNotification($input: SendAdminNotificationInput!) {
    sendAdminNotification(input: $input)
  }
`;
